import type { ArtThemeName } from "@art/shared-ui";
import { APPLICATION_CODES, applicationCodeForPath } from "./license";

export interface ApplicationBrand {
  applicationCode: string | null;
  themeName: ArtThemeName;
  logo: {
    src: string;
    short: string;
    alt: string;
  };
}

const ART_LOGO = {
  src: "/assets/images/A-Realtime-Tech.svg",
  short: "/assets/images/A-Realtime-Tech-short-logo.svg",
  alt: "A Realtime Tech",
};

const PRODUCT_BRANDS: Record<string, Pick<ApplicationBrand, "themeName" | "logo">> = {
  [APPLICATION_CODES.LIVE_CONNECT]: {
    themeName: "default",
    logo: {
      src: "/assets/images/live-connect.svg",
      short: "/assets/images/live-connect-short.svg",
      alt: "ART Live Connect",
    },
  },
  [APPLICATION_CODES.AGENT_LAB]: {
    themeName: "agentLab",
    logo: {
      src: "/assets/images/agent-lab.svg",
      short: "/assets/images/agent-lab-short.svg",
      alt: "ART Agent Lab",
    },
  },
  [APPLICATION_CODES.DATALAKE]: {
    themeName: "datalake",
    logo: {
      src: "/assets/images/datalake.svg?v=cosmic-memory",
      short: "/assets/images/datalake-short.svg?v=cosmic-memory",
      alt: "ART Datalake",
    },
  },
};

function productCodeForPath(pathname: string): string | null {
  if (pathname.startsWith("/live")) return APPLICATION_CODES.LIVE_CONNECT;
  if (pathname.startsWith("/agent-builder")) return APPLICATION_CODES.AGENT_LAB;
  if (pathname.startsWith("/datalake")) return APPLICATION_CODES.DATALAKE;
  if (pathname.startsWith("/platform-settings")) {
    return applicationCodeForPath(pathname);
  }
  return null;
}

export function applicationBrandForPath(pathname: string): ApplicationBrand {
  const applicationCode = productCodeForPath(pathname);
  const productBrand = applicationCode ? PRODUCT_BRANDS[applicationCode] : null;

  if (productBrand) {
    return { applicationCode, ...productBrand };
  }

  if (pathname.startsWith("/marketplace")) {
    return {
      applicationCode: APPLICATION_CODES.MARKETPLACE,
      themeName: "default",
      logo: {
        src: "/assets/images/logo-art-marketplace.png",
        short: "/assets/images/logo-art-marketplace.png",
        alt: "ART Marketplace",
      },
    };
  }

  return {
    applicationCode: null,
    themeName: "default",
    logo: ART_LOGO,
  };
}
